/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.error\":[\"Octagon with exclamation point\"]}");